<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item class="count-data">
                    <i class="el-icon-s-data" style="margin-right: 10px;"></i>
                    销售部门总数：{{deparmentCount}}
                    <span style="padding-left: 10px;"
                          v-if="showPersonal">丨&nbsp;&nbsp;{{userName}}个人总数：{{personalCount}}</span>
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList('search')">
                <el-form-item label="客户姓名">
                    <el-input v-model="dataForm.cusName" placeholder="请输入客户姓名" clearable></el-input>
                </el-form-item>
                <el-form-item label="业务员">
                    <el-select v-model="dataForm.userId"
                               @focus="setHidden"
                               @blur="setHidden"
                               filterable
                               placeholder="请选择" clearable>
                        <el-option
                                v-for="item in userList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            <span style="float: left">
                                {{ item.label }}
                                <span style="color: #8492a6; font-size: 12px;">（{{item.isWork ? '离职' : '在职'}}）</span>
                            </span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="手机号码">
                    <el-input v-model="dataForm.cusMobile" placeholder="请输入手机号码" clearable></el-input>
                </el-form-item>
                <el-form-item label="小区地址">
                    <el-input v-model="dataForm.cusHouse" placeholder="请输入小区地址" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="getDataList('search')" icon="el-icon-search">查询</el-button>
                    <el-button type="primary" @click="addOrUpdateHandle()"
                               v-if="isAuth('invite-add')">新增
                    </el-button>
                    <el-button type="danger" @click="deleteHandle()"
                               v-if="isAuth('invite-delete')"
                               :disabled="dataListSelections.length <= 0">批量删除
                    </el-button>
                    <el-button type="primary" @click="exportData()">导出数据
                    </el-button>
                </el-form-item>
            </el-form>
            <el-table
                    :data="dataList"
                    border
                    v-loading="dataListLoading"
                    @sort-change="customerSort"
                    @selection-change="selectionChangeHandle"
                    style="width: 100%;">
                <el-table-column
                        type="selection"
                        header-align="center"
                        align="center"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="id"
                        header-align="center"
                        align="center"
                        width="80"
                        label="编号">
                </el-table-column>
                <el-table-column
                        prop="cusName"
                        header-align="center"
                        align="center"
                        width="100"
                        :show-overflow-tooltip="true"
                        label="客户姓名">
                </el-table-column>
                <el-table-column
                        prop="cusMobile"
                        header-align="center"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="手机号码">
                </el-table-column>
                <el-table-column
                        prop="cusHouse"
                        header-align="center"
                        align="center"
                        sortable
                        :show-overflow-tooltip="true"
                        label="小区">
                </el-table-column>
                <el-table-column
                        prop="remark"
                        header-align="center"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="需求备注">
                    <template slot-scope="scope">
                        <span>{{scope.row.remark===''?'暂无':scope.row.remark}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="userName"
                        header-align="center"
                        align="center"
                        width="100"
                        sortable
                        :show-overflow-tooltip="true"
                        label="业务员">
                </el-table-column>
                <el-table-column
                        prop="design"
                        header-align="center"
                        align="center"
                        width="100"
                        sortable
                        :show-overflow-tooltip="true"
                        label="设计师">
                </el-table-column>
                <el-table-column
                        prop="state"
                        header-align="center"
                        align="center"
                        :sortable="'custom'"
                        :show-overflow-tooltip="true"
                        label="客户情况">
                    <template slot-scope="scope">
                        <template v-if="scope.row.state === 1">
                            <el-tag v-if="scope.row.intention===1">A+</el-tag>
                            <el-tag v-if="scope.row.intention===2" type="success">A</el-tag>
                            <el-tag v-if="scope.row.intention===3" type="warning">B</el-tag>
                            <el-tag v-if="scope.row.intention===4" type="danger" color="#ffecec"
                                    style="border-color: #ffd9d9">C
                            </el-tag>
                            <el-tag v-if="scope.row.intention===5" type="info">未成交</el-tag>
                        </template>
                        <template v-if="scope.row.state === 2">
                            <el-tag v-if="scope.row.orderPrice===1" type="warning">意向金</el-tag>
                            <el-tag v-if="scope.row.orderPrice===2" type="success">定金20000</el-tag>
                            <el-tag v-if="scope.row.orderPrice===3">货款80%</el-tag>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="creationDate"
                        header-align="center"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="创建时间">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        header-align="center"
                        align="center"
                        width="150"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini"
                                   v-if="isAuth('invite-edit')"
                                   @click="addOrUpdateHandle(scope.row.id)">编辑
                        </el-button>
                        <el-button type="danger" size="mini"
                                   v-if="isAuth('invite-delete')"
                                   @click="deleteHandle(scope.row.id)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    @size-change="sizeChangeHandle"
                    @current-change="currentChangeHandle"
                    :current-page="pageIndex"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    :total="totalPage"
                    layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </div>
        <invite-add-or-update v-if="addOrUpdateVisible" ref="invite"
                              @getDataList="getDataList()"></invite-add-or-update>
    </div>
</template>

<script>
    import {Invite} from "../../api/invite";
    import {UdUser} from "../../api/udUser";
    import InviteAddOrUpdate from './invite-add-or-update';
    import {DateFormat} from "../../utils/dateformat";

    export default {
        name: "invite",
        data() {
            return {
                dataForm: {
                    cusName: '',
                    userId: '',
                    cusMobile: '',
                    cusHouse: '',
                    column: '',
                    order: ''
                },
                userList: [],
                designList: [],
                dataList: [],
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                addOrUpdateVisible: false,
                showPersonal: false,
                personalCount: '',
                deparmentCount: ''
            }
        },
        computed: {
            userName() {
                let userList = this.userList;
                let current = this.dataForm.userId;
                for (let i = 0; i < userList.length; i++) {
                    if (userList[i].value === current) {
                        //console.log(userList[i].label);
                        return userList[i].label;
                    }
                }
                return '';
            }
        },
        components: {
            InviteAddOrUpdate
        },
        created() {
            this.getDataList();
            this.getUserList();
        },
        activated() {
            this.getDataList();
            this.getUserList();
        },
        watch: {
            'dataForm.userId': {
                handler(newValue, oldValue) {
                    if (newValue === '') {
                        this.setHidden();
                    }
                }
            }
        },
        methods: {
            setHidden() {
                this.showPersonal = false;
            },
            /**
             * 自定义排序（客户情况）
             **/
            customerSort(obj) {
                this.dataForm.column = obj.prop;
                this.dataForm.order = obj.order;
                this.getDataList('search');
            },
            //数据导出
            exportData() {
                let sheet = '销售部邀约客户数据' + DateFormat.dateFormat(new Date());
                let columns = [
                    {key: 'id', title: '编号'},
                    {key: 'cusName', title: '客户姓名'},
                    {key: 'cusMobile', title: '手机号码'},
                    {key: 'cusHouse', title: '小区地址'},
                    {key: 'cusApartment', title: '户型'},
                    {key: 'styleLike', title: '风格喜好'},
                    {key: 'stateTitle', title: '客户情况'},
                    {key: 'intention', title: '意向'},
                    {key: 'orderPrice', title: '订单'},
                    {key: 'userName', title: '业务员'},
                    {key: 'remark', title: '需求备注'},
                    {key: 'creationDate', title: '创建时间'}
                ];
                Invite.getInvites().then(res => {
                    if (res.code === 0) {
                        let exportList = res.invites;
                        this.Excel.exportExcel(columns, exportList, sheet);
                    } else {
                        this.$message.info('数据太多无法导出，请联系管理员！')
                    }
                })
            },
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val;
                this.pageIndex = 1;
                this.getDataList();
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val;
                this.getDataList();
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val;
            },
            getUserList() {
                UdUser.getUserList().then(res => {
                    if (res.code === 0) {
                        let userList = res.userList;
                        this.userList = [];
                        this.designList = [];
                        userList.forEach((item, index) => {
                            if (item.deparment === 7) { // 获取销售部人员
                                this.userList.push(item);
                            }
                            if (item.deparment === 6) { // 获取设计师
                                this.designList.push(item);
                            }
                        });
                    }
                })
            },
            /**
             * 获取数据
             * @param type
             */
            getDataList(type) {
                this.dataListLoading = true;
                if (type === 'search') {
                    this.pageIndex = 1;
                }
                let params = {
                    'pageIndex': this.pageIndex,
                    'limit': this.pageSize,
                    'cusName': this.dataForm.cusName,
                    'userId': this.dataForm.userId,
                    'cusMobile': this.dataForm.cusMobile,
                    'cusHouse': this.dataForm.cusHouse,
                    'column': this.dataForm.column,
                    'order': this.dataForm.order
                };
                Invite.getInviteList(params).then(res => {
                    if (res.code === 0) {
                        this.dataList = res.page.list;
                        this.totalPage = res.page.totalCount;
                        if (this.dataForm.userId) {
                            this.showPersonal = true;
                            this.personalCount = res.page.totalCount;
                        } else {
                            this.showPersonal = false;
                            this.deparmentCount = res.page.totalCount;
                        }
                    }
                    this.dataListLoading = false;
                });
            },
            /**
             * 添加或编辑
             * @param id
             */
            addOrUpdateHandle(id) {
                this.addOrUpdateVisible = true;
                this.$nextTick(() => {
                    this.$refs.invite.init(id)
                })
            },
            /**
             * 删除
             */
            deleteHandle(id) {
                let ids = id ? id.toString() : this.dataListSelections.map(item => item.id).join();
                //console.log(ids)
                let arrayIds = {'ids': ids};
                this.$confirm('此操作将删除邀约客户信息, 确定吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    Invite.deleteInvite(arrayIds).then(res => {
                        if (res.code === 0) {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.$nextTick(() => {
                                        this.getDataList();
                                    })
                                }
                            })
                        }
                    })
                }).catch(() => {
                })
            }
        }
    }
</script>

<style scoped>

    .el-tag {
        width: 88px;
        font-size: 14px;
        font-weight: bold;
    }

    .count-data {
        margin: 5px 0;
    }

    .count-data /deep/ .el-breadcrumb__inner {
        color: #606266;
        padding-left: 10px;
        font-size: 18px;
        letter-spacing: 1px;
    }

    .count-data /deep/ .el-breadcrumb__inner:hover {
        color: black;
    }

</style>
